import { Button, ClickableDiv } from '@wwe-portal/ui/components/button';
import { Glowing } from '@wwe-portal/ui/effects/glowing';
import { useSuperstarDetailContext, useSuperstarDetailId } from './context';

import { StickyTopMenu } from '@wwe-portal/ui/components/navigation';
import { sendSuperstarSetBaseButtonClickEvent } from '@wwe-portal/web/libs/analytics/superstars-v2';
import { ShowcaseTarget } from '@wwe-portal/ui/components/showcase/primitives';
import {
  SUPERSTAR_DETAILS_TUTORIAL_TARGET_IDS,
  SUPERSTAR_DETAILS_TUTORIAL_SHOWCASE_ID,
} from '@wwe-portal/web/utils/superstar-details/constants';

export const RosterCompareButtonConsumer = () => {
  const setBaseStats = useSuperstarDetailContext((state) => state.setBaseStats);
  const resetCompareStats = useSuperstarDetailContext(
    (state) => state.resetCompareStats
  );
  const compareEffect = useSuperstarDetailContext(
    (state) => state.compareEffect
  );
  const isRabasing = compareEffect.isActive && compareEffect.from === 'left';
  const superstarId = useSuperstarDetailId();
  const handleClick = () => {
    if (isRabasing) return;
    sendSuperstarSetBaseButtonClickEvent(superstarId);
    setBaseStats();
  };

  return (
    <StickyTopMenu
      fluid={false}
      className="data-[sticky=true]:drop-shadow-card top-[68px] mt-4 data-[sticky=true]:rounded-t-lg xl:top-[78px]"
    >
      <div className="relative flex items-center justify-center">
        <Glowing asChild active={isRabasing}>
          <ShowcaseTarget
            showCaseId={SUPERSTAR_DETAILS_TUTORIAL_SHOWCASE_ID}
            targetId={SUPERSTAR_DETAILS_TUTORIAL_TARGET_IDS.SET_BASE}
          >
            <Button
              variant="orangeGradient"
              className="drop-shadow-card px-12 uppercase"
              onClick={handleClick}
            >
              <span className="drop-shadow-text-2 text-xs font-bold italic">
                Set Base
              </span>
            </Button>
          </ShowcaseTarget>
        </Glowing>
        <div className="absolute inset-y-0 right-0 flex items-center">
          <ClickableDiv
            className="hover:text-green700 px-2 text-xs font-medium italic underline underline-offset-4"
            onClick={resetCompareStats}
          >
            RESET
          </ClickableDiv>
        </div>
      </div>
    </StickyTopMenu>
  );
};
